import {
  isWholeLifePolicy,
  getProductLineByPolicyType,
  isPolicyInGrace,
} from "js/utilities";
import { AgentData } from "context/Agent/DataProvider";
import { useState, useEffect, useContext } from "react";
import moment from "moment";

export const usePoliciesFiltering = (
  keyword,
  type,
  paymentStatus,
  policyType
) => {
  const { agentPolicies } = useContext(AgentData);
  const [policyLookUpData, setPolicyLookUpData] = useState([]);

  // filtering by payment
  async function filterByPayment(data) {
    let policyList = [];
    let searchPaymentCriteria =
      paymentStatus?.length > 0 ? paymentStatus.split(",") : undefined;
    let approved =
      searchPaymentCriteria?.length > 0
        ? searchPaymentCriteria.find((x) => x.toLowerCase() === "approved")
        : undefined;
    let paymentDeclined =
      searchPaymentCriteria?.length > 0
        ? searchPaymentCriteria.find((x) => x.toLowerCase() === "declined")
        : undefined;
    let returned =
      searchPaymentCriteria?.length > 0
        ? searchPaymentCriteria.find((x) => x.toLowerCase() === "returned")
        : undefined;
    let notreceived =
      searchPaymentCriteria?.length > 0
        ? searchPaymentCriteria.find((x) => x.toLowerCase() === "notreceived")
        : undefined;

    if (paymentStatus) {
      if (approved) {
        let selectedPolicy = data.filter(
          (p) => p.paymentStatus?.toLowerCase() === "approved"
        );
        if (selectedPolicy) policyList.push(...selectedPolicy);
      }
      if (paymentDeclined) {
        let selectedPolicy = data.filter(
          (p) => p.paymentStatus?.toLowerCase() === "declined"
        );
        if (selectedPolicy) policyList.push(...selectedPolicy);
      }
      if (returned) {
        let selectedPolicy = data.filter(
          (p) => p.paymentStatus?.toLowerCase() === "returned"
        );
        if (selectedPolicy) policyList.push(...selectedPolicy);
      }
      if (notreceived) {
        let selectedPolicy = data.filter(
          (p) => p.paymentStatus?.toLowerCase() === "not received"
        );
        if (selectedPolicy) policyList.push(...selectedPolicy);
      }
      return policyList;
    } else {
      return data;
    }
  }

  async function filterByPolicyId(data) {
    let policyList = [];
    if (keyword) {
      data.forEach((policy) => {
        if (
          policy.oldPolicy
            ?.toLowerCase()
            .startsWith(keyword?.trim()?.toLowerCase())
        ) {
          policyList.push(policy);
        } else {
          let party = policy?.parties?.filter((p) =>
            p.person?.fullName
              ?.toLowerCase()
              ?.startsWith(keyword?.trim()?.toLowerCase())
          );
          if (party?.length) {
            policyList.push(policy);
          }
        }
      });
      return policyList;
    }
    return data;
  }

  async function filterByType(data) {
    if (!type) return data;
    let selectedPolicy = [];
    let searchCriteria = type?.length > 0 ? type.split(",") : undefined;
    let all =
      searchCriteria?.length > 0
        ? searchCriteria.find((x) => x.toLowerCase() === "all")
        : undefined;
    let inforce =
      searchCriteria?.length > 0
        ? searchCriteria.find((x) => x.toLowerCase() === "inforce")
        : undefined;
    let ingrace =
      searchCriteria?.length > 0
        ? searchCriteria.find((x) => x.toLowerCase() === "ingrace")
        : undefined;
    let reinstated =
      searchCriteria?.length > 0
        ? searchCriteria.find((x) => x.toLowerCase() === "reinstated")
        : undefined;
    let inactive =
      searchCriteria?.length > 0
        ? searchCriteria.find((x) => x.toLowerCase() === "inactive")
        : undefined;
    let declined =
      searchCriteria?.length > 0
        ? searchCriteria.find((x) => x.toLowerCase() === "declined")
        : undefined;
    let lapsed =
      searchCriteria?.length > 0
        ? searchCriteria.find((x) => x.toLowerCase() === "lapsed")
        : undefined;
    let conditionallyIssued =
      searchCriteria?.length > 0
        ? searchCriteria.find((x) => x.toLowerCase() === "conditionallyissued")
        : undefined;
    let policyList = [];
    if (all) {
      return data;
    } else {
      if (inforce) {
        selectedPolicy = data.filter(
          (x) =>
            (x.status?.toLowerCase() === "active" ||
              x.status?.toLowerCase() === "paid-up" ||
              x.status?.toLowerCase() === "reducedpaidup" ||
              x.status?.toLowerCase() === "") &&
            !isPolicyInGrace(x)
        );

        policyList.push(...selectedPolicy);
      }
      if (ingrace) {
        selectedPolicy = data.filter((x) => isPolicyInGrace(x));

        policyList.push(...selectedPolicy);
      }
      if (reinstated) {
        selectedPolicy = data.filter(
          (x) => x.status?.toLowerCase() === "reinstated"
        );

        policyList.push(...selectedPolicy);
      }
      if (inactive) {
        selectedPolicy = data.filter(
          (x) =>
            x.status?.toLowerCase() === "inactive" ||
            x.status?.toLowerCase() === "terminated" ||
            x.status?.toLowerCase() === "cancelled" ||
            x.status?.toLowerCase() === "surrendered" ||
            x.status?.toLowerCase() === "matured" ||
            x.status?.toLowerCase() === "deceased" ||
            x.status?.toLowerCase() === "expired" ||
            x.status?.toLowerCase() === "term conversion" ||
            x.status?.toLowerCase() === "extended term" ||
            x.status?.toLowerCase() === "administrative rewrite"
        );
        selectedPolicy?.forEach((p) => {
          let duration = moment().diff(moment(p?.statusDate), "years", true);
          if (duration <= 2) {
            policyList.push(p);
          }
        });
      }

      if (declined) {
        selectedPolicy = data.filter(
          (x) => x.status?.toLowerCase() === "declined"
        );
        policyList.push(...selectedPolicy);
      }
      if (lapsed) {
        selectedPolicy = data.filter(
          (x) => x.status?.toLowerCase() === "lapsed"
        );
        policyList.push(...selectedPolicy);
      }
      if (conditionallyIssued) {
        selectedPolicy = data.filter(
          (x) => x.status?.toLowerCase() === "conditionally issued"
        );
        policyList.push(...selectedPolicy);
      }
      return policyList;
    }
  }

  async function filterByPolicyType(data) {
    const filteredByPolicyType = [];
    const searchpolicyTypeCriteria = policyType.split(",");

    searchpolicyTypeCriteria.forEach((type) => {
      switch (type) {
        case "annuity":
          filteredByPolicyType.push(
            ...data.filter(
              (policy) =>
                getProductLineByPolicyType(policy.product.type) === "Annuity"
            )
          );
          break;
        case "wholelife":
          filteredByPolicyType.push(
            ...data.filter((policy) => isWholeLifePolicy(policy.product.type))
          );
          break;
        case "universallife":
          filteredByPolicyType.push(
            ...data.filter((policy) => policy.product.type === "LU")
          );
          break;
        default:
        case "termlife":
          filteredByPolicyType.push(
            ...data.filter((policy) =>
              policy?.product?.type?.toUpperCase()?.startsWith("LT")
            )
          );
          break;
      }
    });

    return filteredByPolicyType;
  }

  async function finalFiltering() {
    let policyList = agentPolicies;
    if (keyword) policyList = await filterByPolicyId(policyList);
    if (type) policyList = await filterByType(policyList);
    if (paymentStatus) policyList = await filterByPayment(policyList);
    if (policyType) policyList = await filterByPolicyType(policyList);
    setPolicyLookUpData(policyList);
  }
  useEffect(() => {
    finalFiltering();
  }, [agentPolicies, keyword, type, paymentStatus, policyType]);

  return {
    policies: policyLookUpData,
  };
};
